import React from 'react';

import classnames from 'classnames';

import {Text, Icon, Expandable, WithToggle} from '@albert-io/atomic';

import sessionStore from 'client/Session/SessionStore';

import './expandable-chip.scss';

interface ExpandableChipProps {
  children?: React.ReactNode;
  text: string;
  onCancel?: () => void;
  onExpandToggle?: (on: boolean) => void;
  className?: string;
  id: string;
  count?: number;
  showCount?: boolean;
}

export const ExpandableChip = ({
  children,
  text,
  className,
  id,
  count = 0,
  showCount,
  onCancel = () => {},
  onExpandToggle = () => {}
}: ExpandableChipProps) => {
  const buttonId = `expandable-button-${id}`;
  const expandableId = `expandable-area-${id}`;

  return (
    <WithToggle freeze>
      {({onClick, on}) => (
        <div className={classnames('expandable-chip', className)}>
          <div
            className={classnames(
              'expandable-chip__primary u-mar_0 u-max-width_100pc u-width_100pc',
              {
                'expandable-chip--expanded': on,
                'expandable-chip--closed': !on
              }
            )}
          >
            <div className='u-display_flex u-overflow_hidden u-width_100pc'>
              {children && (
                <button
                  type='button'
                  className='expandable-chip__button'
                  aria-label={`${on ? 'hide' : 'show'} selected standards`}
                  onClick={(e) => {
                    onExpandToggle?.(on);
                    onClick(e);
                  }}
                >
                  <Icon color='inherit' icon={on ? 'chevron-down' : 'chevron-right'} />
                </button>
              )}
              <div className='u-display_flex u-flex_1 u-overflow_hidden u-gap_2 u-flex-direction_row u-justify-content_space-between u-align-items_center'>
                <Text
                  className='expandable-chip__primary-title u-pad-l_1'
                  color='inherit'
                  as='div'
                  size='xs'
                  title={text}
                  bold
                >
                  {text}
                </Text>
                {
                  /*
                    TODO: Enable for all users once feature is complete
                    See https://github.com/albert-io/nexus/issues/7059
                  */
                  sessionStore.isSuper() && showCount && (
                    <Text as='div' size='xs' className='expandable-chip_question-count'>
                      {`(${count})`}
                    </Text>
                  )
                }
              </div>
            </div>
            <button
              aria-label={`remove ${text} and all associated sets`}
              onClick={onCancel}
              type='button'
              className='expandable-chip__button expandable-chip__primary-close-button'
            >
              <Icon color='inherit' icon='times' />{' '}
            </button>
          </div>
          {children && (
            <Expandable
              className='expandable-chip__section'
              aria-labelledby={buttonId}
              expanded={on}
              id={expandableId}
            >
              <ul className='u-mar_0 u-pad_0'>{children}</ul>
            </Expandable>
          )}
        </div>
      )}
    </WithToggle>
  );
};
